export type Orientation = "landscape" | "portrait";

/**
 * Returns the current screen orientation.
 */
export const getOrientation = (): Orientation => {
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
};
